import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mb-4" }
const _hoisted_2 = {
  key: 0,
  class: "mt-4"
}
const _hoisted_3 = {
  key: 1,
  class: "mt-4"
}

import {computed, nextTick, ref, watch} from 'vue';
import router from '@/router';
import {doAlert} from '@/util';
import Contact, {ApiContactSubmitData} from '@/model/Contact';
import {postContact, putContact} from '@/api/module/contact';
import DatePicker from '@/components/DatePicker.vue';
import useDetailContacts from '@/store/detailContact';
import {useRoute} from 'vue-router';
import {VNodeRef} from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ContactCreate',
  setup(__props, { expose: __expose }) {

const route = useRoute();
const detailContactStore = useDetailContacts();
const loadingSave = ref(false);
const isEdit = route.params.contact_id !== undefined;
const contact = ref<ApiContactSubmitData>({
  Nachname: '',
  Vorname: null,
  Position: '',
  Abteilung: '',
  AufgabenGebiet: '',
  AustrittDatum: '',
  Anrede: '',
  Titel: null,
  Briefanrede: '',
  Name1: '',
  Name2: null,
  Name3: '',
  Strasse: '',
  NAT: 'D',
  Plz: '',
  Ort: '',
  Postfach: null,
  PostfachPlz: null,
  PostfachOrt: null,
  Telefon1: '',
  Telefon2: '',
  Telefax: '',
  Email: null,
  Homepage: '',
  Info1: '',
  Info2: '',
});
const formValid = ref(false);
const form = ref<HTMLFormElement & VNodeRef | undefined>();

async function save() {
  try {
    loadingSave.value = true;
    form.value?.validate();
    if (!formValid.value) {
      throw new Error('Bitte alle Felder korrekt ausfüllen');
    }
    contact.value.Vorname = contact.value.Vorname ? contact.value.Vorname : null;
    contact.value.Email = contact.value.Email ? contact.value.Email : null;
    const nameData = [contact.value.Nachname];
    if (contact.value.Vorname) nameData.push(contact.value.Vorname);
    contact.value.Name1 = nameData.join(', ');
    contact.value.AustrittDatum = contact.value.AustrittDatum ? contact.value.AustrittDatum : null;
    contact.value.Briefanrede = `Sehr geehrte${
          contact.value.Anrede === 'Herr' ? 'r' : ''
    } ${contact.value.Anrede} ${contact.value.Nachname}`;
    contact.value.Info1 = contact.value.Info1 ? contact.value.Info1 : null;
    contact.value.Info2 = contact.value.Info2 ? contact.value.Info2 : null;
    let contactFromApi;
    if (isEdit) {
      contactFromApi = await putContact(Number(route.params.id), Number(route.params.contact_id), contact.value);
    } else {
      contactFromApi = await postContact(Number(route.params.id), [contact.value]);
    }
    await detailContactStore.replace([contactFromApi, 1]);
    router.back();
  } catch (err: any) {
    await doAlert(err.message, 'Fehler');
  } finally {
    loadingSave.value = false;
  }
}
function ruleRequired(val: string | null | undefined): string | true {
  if (!val) return 'erforderlich';

  return true;
}
function ruleEmailValid(val: string | null | undefined): string | true {
  return (
    !val || /^[a-z0-9!#$%&'*+/=?^_'{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_'{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/.test(val) ||
        'E-Mail muss gültig sein'
  );
}
function rulePhoneNumber(val: string | null | undefined): string | true {
  return (
    !val ||
        /^\+?[() /\-0-9]+$/.test(val) ||
        'Telefonnummer ungültig'
  );
}
function ruleMaxLength(maxLength: number): (val: string | null | number | undefined) => string | true {
  return (val) => {
    if (!val) return true;
    if (val.toString().length > maxLength) return `maximal ${maxLength} Zeichen`;

    return true;
  };
}

const austrittsDatum = computed({
  get(): string {
    return contact.value.AustrittDatum ?? '';
  },
  set(newDate: string | undefined) {
    if (!newDate) {
      contact.value.AustrittDatum = '';
      return;
    }
    contact.value.AustrittDatum = newDate;
  },
});

watch(() => detailContactStore.data, async (data: Contact | null) => {
  if (isEdit && data) {
    contact.value.Nachname = data.Nachname ?? '';
    contact.value.Vorname = data.Vorname ?? '';
    contact.value.Position = data.Position ?? '';
    contact.value.Abteilung = data.Abteilung ?? '';
    contact.value.AufgabenGebiet = data.AufgabenGebiet ?? '';
    contact.value.AustrittDatum = data.AustrittDatum?.slice(0, 10) ?? '';
    contact.value.Anrede = data.Anrede ?? '';
    contact.value.Briefanrede = data.Briefanrede ?? '';
    contact.value.Strasse = data.Strasse ?? '';
    contact.value.Plz = data.Plz ?? '';
    contact.value.Ort = data.Ort ?? '';
    contact.value.Telefon1 = data.Telefon1 ?? '';
    contact.value.Telefon2 = data.Telefon2 ?? '';
    contact.value.Email = data.Email ?? '';
    contact.value.Homepage = data.Homepage ?? '';
    contact.value.Info1 = data.Info1 ?? '';
    contact.value.Info2 = data.Info2 ?? '';
  }
  await nextTick();
  form.value?.validate();
}, {immediate: true});
watch(form, () => {
  form.value?.validate();
});

__expose({
  form,
  austrittsDatum,
  contact,
  detailContactStore,
  save,
  ruleEmailValid,
  ruleMaxLength,
  rulePhoneNumber,
  ruleRequired,
});

return (_ctx: any,_cache: any) => {
  const _component_v_radio = _resolveComponent("v-radio")!
  const _component_v_radio_group = _resolveComponent("v-radio-group")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_error = _resolveComponent("error")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_overlay = _resolveComponent("v-overlay")!

  return (_openBlock(), _createElementBlock("div", null, [
    (!(isEdit && _unref(detailContactStore).loading) && !_unref(detailContactStore).error)
      ? (_openBlock(), _createBlock(_component_v_container, { key: 0 }, {
          default: _withCtx(() => [
            _createVNode(_component_v_form, {
              modelValue: formValid.value,
              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((formValid).value = $event)),
              ref: form.value
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_radio_group, {
                  modelValue: contact.value.Anrede,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((contact.value.Anrede) = $event)),
                  rules: [ruleRequired],
                  inline: "",
                  label: "Anrede *"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_radio, {
                      label: "Herr",
                      value: "Herr"
                    }),
                    _createVNode(_component_v_radio, {
                      label: "Frau",
                      value: "Frau"
                    })
                  ], undefined, true),
                  _: 1
                }, 8, ["modelValue", "rules"]),
                _createVNode(_component_v_text_field, {
                  modelValue: contact.value.Vorname,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((contact.value.Vorname) = $event)),
                  label: "Vorname",
                  rules: [ruleMaxLength(30)]
                }, null, 8, ["modelValue", "rules"]),
                _createVNode(_component_v_text_field, {
                  modelValue: contact.value.Nachname,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((contact.value.Nachname) = $event)),
                  label: "Nachname *",
                  rules: [ruleRequired, ruleMaxLength(30)]
                }, null, 8, ["modelValue", "rules"]),
                _createVNode(_component_v_text_field, {
                  modelValue: contact.value.Position,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((contact.value.Position) = $event)),
                  label: "Position",
                  rules: [ruleMaxLength(30)]
                }, null, 8, ["modelValue", "rules"]),
                _createVNode(_component_v_text_field, {
                  modelValue: contact.value.Abteilung,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((contact.value.Abteilung) = $event)),
                  label: "Abteilung",
                  rules: [ruleMaxLength(30)]
                }, null, 8, ["modelValue", "rules"]),
                _createVNode(_component_v_text_field, {
                  modelValue: contact.value.AufgabenGebiet,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((contact.value.AufgabenGebiet) = $event)),
                  label: "Aufgabengebiet",
                  rules: [ruleMaxLength(30)]
                }, null, 8, ["modelValue", "rules"]),
                _createVNode(DatePicker, {
                  class: "mt-5",
                  modelValue: austrittsDatum.value,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((austrittsDatum).value = $event)),
                  label: "Austrittsdatum"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_v_text_field, {
                  modelValue: contact.value.Strasse,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((contact.value.Strasse) = $event)),
                  label: "Strasse",
                  rules: [ruleMaxLength(42)]
                }, null, 8, ["modelValue", "rules"]),
                _createVNode(_component_v_text_field, {
                  modelValue: contact.value.Plz,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((contact.value.Plz) = $event)),
                  label: "PLZ",
                  rules: [ruleMaxLength(10)]
                }, null, 8, ["modelValue", "rules"]),
                _createVNode(_component_v_text_field, {
                  modelValue: contact.value.Ort,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((contact.value.Ort) = $event)),
                  label: "Ort",
                  rules: [ruleMaxLength(42)]
                }, null, 8, ["modelValue", "rules"]),
                _createVNode(_component_v_text_field, {
                  modelValue: contact.value.Telefon1,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((contact.value.Telefon1) = $event)),
                  label: "Telefon",
                  rules: [ruleMaxLength(20)]
                }, null, 8, ["modelValue", "rules"]),
                _createVNode(_component_v_text_field, {
                  modelValue: contact.value.Telefon2,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((contact.value.Telefon2) = $event)),
                  label: "Mobil",
                  rules: [ruleMaxLength(20)]
                }, null, 8, ["modelValue", "rules"]),
                _createVNode(_component_v_text_field, {
                  modelValue: contact.value.Email,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((contact.value.Email) = $event)),
                  label: "E-Mail",
                  rules: [ruleEmailValid, ruleMaxLength(255)]
                }, null, 8, ["modelValue", "rules"]),
                _createVNode(_component_v_text_field, {
                  modelValue: contact.value.Homepage,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((contact.value.Homepage) = $event)),
                  label: "Homepage",
                  rules: [ruleMaxLength(60)]
                }, null, 8, ["modelValue", "rules"]),
                _createVNode(_component_v_text_field, {
                  modelValue: contact.value.Info1,
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((contact.value.Info1) = $event)),
                  label: "Info1",
                  rules: [ruleMaxLength(30)]
                }, null, 8, ["modelValue", "rules"]),
                _createVNode(_component_v_text_field, {
                  modelValue: contact.value.Info2,
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((contact.value.Info2) = $event)),
                  label: "Info2",
                  rules: [ruleMaxLength(30)]
                }, null, 8, ["modelValue", "rules"]),
                _createVNode(_component_v_btn, {
                  color: "primary",
                  onClick: save,
                  disabled: !formValid.value,
                  loading: loadingSave.value
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Speichern")
                  ], undefined, true),
                  _: 1
                }, 8, ["disabled", "loading"])
              ], undefined, true),
              _: 1
            }, 8, ["modelValue"])
          ], undefined, true),
          _: 1
        }))
      : (_unref(detailContactStore).error)
        ? (_openBlock(), _createBlock(_component_error, {
            key: 1,
            module: _unref(detailContactStore).$id
          }, null, 8, ["module"]))
        : _createCommentVNode("", true),
    _createVNode(_component_v_overlay, {
      "model-value": loadingSave.value || (isEdit && _unref(detailContactStore).loading),
      class: "align-center justify-center",
      persistent: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_text, { class: "text-center" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                  _createVNode(_component_v_progress_circular, { indeterminate: "" })
                ]),
                (isEdit && _unref(detailContactStore).loading)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_2, "Ansprech­partner­erfassung wird geladen"))
                  : _createCommentVNode("", true),
                (loadingSave.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, "Ansprech­partner wird gespeichert"))
                  : _createCommentVNode("", true)
              ], undefined, true),
              _: 1
            })
          ], undefined, true),
          _: 1
        })
      ], undefined, true),
      _: 1
    }, 8, ["model-value"])
  ]))
}
}

})